import styled from 'styled-components/native';
import { colors, dimensions } from '../../../styles';

export const StyledModal = styled.View`
  align-items: center;
  justify-content: center;
`;

export const RootContainer = styled.View`
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: ${colors.white};
`;

export const SwipeableModal = styled.View`
  flex: 1;
  width: ${dimensions.mobileWidth}px;
  min-width: 425px;
  align-items: center;
  margin: 0;
`;

export const SwipeableModalContainer = styled.View`
  flex: 1;
  justify-content: center;
  overflow: hidden;
`;

export const FullScreenModal = styled.View`
  flex: 1;
  margin: 0;
  background-color: ${colors.white};
`;

export const FullScreenContainer = styled.View`
  flex: 1;
  justify-content: center;
`;
